import { gql } from '@apollo/client'

export default gql(`
mutation createFolder($name: String $tags: [String] $project: String $type: String!){
    createFolder(
        input:{
            type:$type
            name:$name
            tags: $tags
            project: $project
        }
        ){
            id
            position
            name,
            createdAt,
            tags{
                key,
                name,
                type,
                module,
                assetCount,
                mediaCount,
                isTransferring
            }
        }
    }
`)
